// extracted by mini-css-extract-plugin
export default {"container":"_2wcSP","timeSlot":"_3JB_n","duration":"_1uAHf","title":"NWNsO","location":"_3smgd","tags":"-Ieue","itemWithIndication":"_1Y2sz"};